import { CHIP_COLORS } from '../../../../../../../../../constants/other'
import {
  APPROVED,
  BUYER_DISAPPROVED,
  DISAPPROVED,
  PENDING_APPROVAL,
  PENDING_BUYER_APPROVAL
} from '../../../../../../../../../features/components/UploadedFilesField/helpers'

export const getStatusChipColor = status => {
  switch (status) {
    case PENDING_BUYER_APPROVAL:
    case APPROVED:
      return CHIP_COLORS.green
    case DISAPPROVED:
    case BUYER_DISAPPROVED:
      return CHIP_COLORS.red
    case PENDING_APPROVAL:
    default:
      return CHIP_COLORS.grey
  }
}
